import React, { useEffect } from 'react';
import { useOAuth } from './hooks/useOAuth';
import LoadingState from '../../components/LoadingState';
import styled from 'styled-components';
import { Color } from '../../app/StyleGuide';
import useQueryParams from '../../hooks/useQueryParams';
import windowService from '../../services/windowService';
import alertService from '../../services/AlertService';
import eventBus from '../../services/globalEventBus';

const NavBarLoadingState = styled.div`
  height: 60px;
  width: 100%;
  background-color: ${Color.Gray._90};
`;

export const OAuth = () => {
  const query = useQueryParams({ preserveParams: true });
  const { signInSSOUser, signInNonSSOUser, signInSSORedirect, signInNonSSORedirect } = useOAuth();

  useEffect(() => {
    const redirectEmail = localStorage.getItem('redirectEmail');
    // If the query has a code and state, we can assume the user is coming from the SSO flow
    if (query?.code && query?.state) {
      if (window.getIsSSO()) {
        if (redirectEmail) {
          signInSSORedirect().catch(handleErrorAndRedirectToLogin);
        } else {
          signInSSOUser().catch(handleErrorAndRedirectToLogin);
        }
      } else {
        if (redirectEmail) {
          signInNonSSORedirect().catch(handleErrorAndRedirectToLogin);
        } else {
          // For non-SSO, use our manual state management
          signInNonSSOUser(query.code, query.state).catch(handleErrorAndRedirectToLogin);
        }
      }
    } else {
      handleErrorAndRedirectToLogin(new Error('Invalid OAuth parameters'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleErrorAndRedirectToLogin = (error: Error | unknown) => {
    eventBus.publish('SignInFailed');
    alertService.showOnNextPage(
      error instanceof Error ? error.message : 'An error occurred. Please try again.',
      'error'
    );
    windowService.redirectTo('/login');
  };

  return (
    <>
      <NavBarLoadingState />
      <LoadingState />
    </>
  );
};
